import { createFileRoute } from "@tanstack/react-router";
import { PackageIcon } from "lucide-react";
import { AssetsView } from "@/components/assets/assets-view";
import { assetsPageQuery, warm } from "@/lib/workspace-queries";

export const Route = createFileRoute("/_workspace/assets/")({
  // A head start on the default view; the page renders its own skeleton.
  loader: ({ context }) => {
    warm(context.queryClient.ensureInfiniteQueryData(assetsPageQuery({})));
  },
  component: AssetsPage,
});

function AssetsPage() {
  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-6xl space-y-6">
        <div className="space-y-1">
          <p className="flex items-center gap-1.5 font-medium text-[10px] text-muted-foreground uppercase tracking-[0.25em]">
            <PackageIcon className="size-3.5" />
            Assets
          </p>
          <h1 className="font-bold text-2xl tracking-tight">Company property</h1>
          <p className="text-muted-foreground text-sm">
            Track company assets and equipment, and see what's assigned to whom.
          </p>
        </div>

        <AssetsView />
      </div>
    </main>
  );
}
